<template>
<div class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header p-2">
          <h5 class="modal-title" v-if="'catalog_type' in selectedCategory && selectedCategory.catalog_type=='photo_album'">{{$t('Rename Album')}}</h5>
          <h5 class="modal-title" v-else-if="'catalog_type' in selectedCategory && selectedCategory.catalog_type=='package'">{{$t('Rename Package')}}</h5>
          <h5 class="modal-title" v-else>{{$t('Rename Catalog(s)')}}</h5>
          <button class="close text-white" data-dismiss="modal" aria-label="Close" @click="closeDialog()">
            <span aria-hidden="true"><cancel-icon class="close-icon" style="height: 30px !important;
    width: 30px !important;
    color: #fff;"></cancel-icon></span>
          </button>
        </div>
        <div class="modal-body">
          <!-- <div class="key-style">Catalog(s)</div> -->
          <input @keyup.enter="updateCategory()" ref="renameField" type="text" class="bg-transparent border rounded text-light form-control input-fields"
           v-model="categoryName" @input="restrictSpecialKeyPress" id="field-edit-catalog">
           <!-- <div v-if="errorMessage" class="config-desc" style="width: 100%;">{{errorMessage}}</div> -->
        </div>
        <div class="modal-footer p-0 primary-btn-style">
          <button class="btn btn-outline-secondary mr-2" data-dismiss="modal" @click.prevent="closeDialog()">{{$t('Cancel')}}</button>
          <button class="btn btn-outline-primary mr-3" @click.prevent="updateCategory()" :class="errorMessage?'disabled':''">{{$t('Rename')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import {mapActions} from "vuex";
import Utils from "../../components.utils.js";
import cancelIcon from "../core/InlineCancelField.vue"


export default {
  props:["selectedCategory"],
  data: () => ({
    dialog: true,
    categoryName:"",
    errorMessage:null
  }),
  methods:{
      restrictSpecialKeyPress(event) {
        console.log("Key pressed: ", event);
        this.errorMessage = null;
      },
      closeDialog(){
          this.$emit("close")
      },
      components:{
        'cancel-icon':cancelIcon
      },
      updateCategory(){
        this.categoryName = this.categoryName.trim();
        if(this.errorMessage){
          return;
        }
        const validation = Utils.isSafeFolderOrFileName(this.categoryName);
        if (!validation.valid) {
          alert(validation.message);
          this.$refs.renameField.focus();
          return;
        }
        if(this.categoryName == null || this.categoryName.trim().length == 0){
            if(this.selectedCategory.catalog_type == "photo_album"){
              alert("Please enter valid Photo Album name");
            }else if(this.selectedCategory.catalog_type == "package"){
              alert("Please enter valid Package name");
            }else{
              alert("Please enter valid Catalog name");
            }
             this.$refs.renameField.focus();
             return false;
          }
          let payload = {_id: this.selectedCategory._id, catalog_name: this.categoryName.trim(), params:{_id:this.selectedCategory._id}}
          this.updateExistingCategory(payload).then((data)=>{
            if (data.statusCode==200){
              this.$toast.success(data.message);
              this.closeDialog()
            }else{
              this.errorMessage = data.message;
              this.$toast.error(data.message);
            }
          })        
      },
    ...mapActions("categories", ["updateExistingCategory"]),
  },
  watch: {
    'errorMessage': function(val){
      if(val){
        this.$refs.renameField.focus();
      }
    }
  },
  created(){
    this.categoryName = this.selectedCategory.catalog_name
  },
  mounted(){
    document.getElementById("field-edit-catalog").focus();
  }
}
</script>

<style lang="scss" scoped>
$table-row-border: none;
$active-blue: #007bff;
$danger-color: #dc3545;
$none-text-color:#4f4f4f;
$add-button-text-color:#0b7099;
$add-button-text-color-hover:#0193cc;
$add-button-border-color:#b7b228;
$add-button-border-on-hover:#dcd426;
$add-button-backgroud:#1e1e1e;
$active-green-color:#28a745;
$primary-background: #1a1e21;
$border-color: 1px solid #4a4a4a;
$primary-background: #1a1e21;
$secondary-background-color:#15181B;
$bg-color-on-hover: #22272b;
$text-color: #eee;
$dull-text-color: #757575;
$secondary-text-color: #9c9c9c;
$active-blue : #007bff;
$input-field-and-label-font-size:14px;
$input-field-height:38px;
$highlight-font-color:#ff9800;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#1a1e21;
$scrollbar-thumb-on-hover-background:#555; 
$input-field-padding:.375rem 10px;
$filter-border-color: #5a5a5a;
$filter-bg-color: #2a2a2a;
$learn-about-text-color-hover:#b7b327;
$learn-about-text-color:#9a9620;
$tags-background-color:#282d31;
$svg-color:#666;
$tags-border-color:#363636;
$secondary-border-color: 1px solid #2b2b2b;
$icon-hover:#2c3339;
.modal-dialog {
    max-width: 600px;
    width: 600px;
    margin: 0;
    padding: 0;
  }
  
  .modal-content {
    height: 227px;
    min-height: 100%;
    border: 0 none;
    border-radius: 0;
    box-shadow: none;
    background: $primary-background !important;
    border: $secondary-border-color;
    .modal-body{
      background: $primary-background;
      padding: 2rem;
    }
  }

.modal {
  text-align: center;
  padding: 0!important;
  display:block;
}
.modal-header .close {
    // margin: -1rem -13px -1rem auto !important;
    margin:0px !important;
    padding: 0px !important;
}
.modal:before {
  content: '';
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-inline-end: -4px;
}
.modal-dialog {
  display: inline-block;
  text-align: start;
  vertical-align: middle;
}

.btn{
    font-size:14px !important;
    height:100%;
}

.border{
    border: $border-color !important;
}

.modal-header,.modal-footer{
    border-top: $secondary-border-color !important;
    border-bottom: $secondary-border-color !important;
    background: $secondary-background-color;
    height: 58px;
    .modal-title{
      color:$text-color;
    }
}

.modal-header{
  align-items:center;
  padding: 16px 24px 10px !important;
}

.primary-btn-style{
    margin-top:1%;
    button{
        height: 35px;
        width: 70px;
        font-size:14px;
    }
}

.secondary-btn-style{
  color:$text-color;
}

.key-style {
  color: $dull-text-color;
  width: 30%;
  text-align: start;
  font-size: $input-field-and-label-font-size;
  padding-inline-start: 5px;
  padding-inline-end: 5px;
  margin-top: 3px;
}

.input-fields {
  border: none !important;
  border-bottom: 1px solid $active-blue !important;
  height:30px;
}

.input-fields:focus {
  outline: unset;
  box-shadow:none;
}
.close-icon:hover{
  background: $icon-hover;
  border-radius: 20px;
}
.config-desc{
  color: $dull-text-color;
  font-size:12px;
}
.config-desc{
  color: $danger-color;
  font-size: 14px;
  margin-top: 7px;
  text-align: initial;
}
</style>